<template>
  <update-business-member-field
    title="Last Appointment"
    :value="formattedLastAppointmentDate"
    :member="member"
    :is-loading="isLoading"
    @update:isLoading="$emit('update:isLoading', $event)"
    :is-editing="isEditing"
    @update:isEditing="handleIsEditing"
    @save="save"
  >
    <base-date-picker placeholder="Select last appointment" v-model="lastAppointmentDate" required />
  </update-business-member-field>
</template>

<script>
import UpdateBusinessMemberField from "@/views/business/member/components/UpdateBusinessMemberField";
import moment from "moment";

export default {
  components: {
    UpdateBusinessMemberField,
  },
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      lastAppointmentDate: "",
    };
  },
  computed: {
    formattedLastAppointmentDate() {
      return this.member.lastAppointmentDate ? moment(this.member.lastAppointmentDate).format("M/D/YYYY") : "-";
    },
  },
  methods: {
    handleIsEditing($event) {
      this.lastAppointmentDate = this.member.lastAppointmentDate;
      this.$emit("update:isEditing", $event);
    },
    save() {
      this.$emit("updated", {
        ...this.member,
        lastAppointmentDate: this.lastAppointmentDate,
      });
    },
  },
};
</script>
